import React from 'react'
import Moment from 'moment'

import {momentRange} from "../../../../gd/convert/moment-range"
import DatetimeUtils from "../../../../gd/utils/datetime-utils"

// @ts-ignore
import TimePicker from "../../../../gd-ui/time-picker/v1/time-picker"

type Props = {
    timeRangeValue?  : MomentRange | null

    skin?            : 'horizontal' | 'vertical'

    fromLabel?       : string
    toLabel?         : string

    format?          : string
    timeStep?        : number // minutes

    deleteAllowed?   : boolean

    onChange?        : callback
}

export default class TimeRange extends React.Component<Props> {

    static defaultProps: Partial<Props> = {
        skin            : 'horizontal',
        fromLabel       : "From",
        toLabel         : "To",
        timeStep        : 15,
        deleteAllowed   : true
    }

    timeRangeValue : MomentRange | null

    constructor(props: Props) {
        super(props)

        this.timeRangeValue = props.timeRangeValue ? props.timeRangeValue : null
    }

    componentDidMount() {
        if (!this.props.deleteAllowed && !this.timeRangeValue) {
            this.addTimeRange(false)
        }
    }

    update = () => {
        this.forceUpdate(() => {
            if (this.props.onChange) {
                this.props.onChange(this.timeRangeValue)
            }
        })
    }

    addTimeRange = (update: any = true) => {
        this.timeRangeValue = momentRange(
            DatetimeUtils.stickToSteps(Moment(), this.props.timeStep),
            DatetimeUtils.stickToSteps(Moment().add(1, 'hour'), this.props.timeStep)
        )

        if (update) {
            this.update()
        } else {
            this.forceUpdate()
        }
    }

    onChangeStart = (value: Moment) => {
        const duration = this.timeRangeValue.end.diff(this.timeRangeValue.start, 'minutes')

        const start = Moment(value)
        const end = Moment(value).add(duration, 'minutes')
        this.timeRangeValue = momentRange(start, end)
        this.update()
    }

    onChangeEnd = (value: Moment) => {
        const start = Moment(this.timeRangeValue.start)
        const end = Moment(value)
        this.timeRangeValue = momentRange(start, end)
        this.update()
    }

    onClearValues = () => {
        this.timeRangeValue = null
        this.update()
    }

    render() {
        if (!this.timeRangeValue) {
            return (
                <div className="gd-time-range empty" onClick={this.addTimeRange}>
                    <div className="icon i5-my-time m-r-10"/>
                    Add time
                </div>
            )
        }

        const classes = Classes("gd-time-range", this.props.skin + "-skin", {
            'with-delete' : this.props.deleteAllowed
        })

        return (
            <div className={classes}>
                <TimePicker className        = "time-selector"
                            value            = {this.timeRangeValue.start}
                            timeStep         = {this.props.timeStep}
                            popoverMinWidth  = {110}
                            onChange         = {this.onChangeStart}>
                    <div className="gd-time-range-field-label ui5-txt-not-important-small">{this.props.fromLabel}</div>
                </TimePicker>
                <div className="time-selector-separator"/>
                <TimePicker className        = "time-selector"
                            minValue         = {this.timeRangeValue.start}
                            value            = {this.timeRangeValue.end}
                            timeStep         = {this.props.timeStep}
                            popoverMinWidth  = {170}
                            onChange         = {this.onChangeEnd}>
                    <div className="gd-time-range-field-label ui5-txt-not-important-small">{this.props.toLabel}</div>
                </TimePicker>
                {this.props.deleteAllowed &&
                    <div className="delete-button ui5-ico-delete s14 gray m-l-10" onClick={this.onClearValues}/>}
            </div>
        )
    }
}
